export const JOB_TITLES = [
  "ADMIN",
  "PROCUREMENT",
  "FINANCE",
  "HR",
  "SECRETARY",
  "BUSINESS_TRAVELER",
  "OTHER",
];

export const INDUSTRIES = [
  "MINING",
  "CONSTRUCTION",
  "OIL_AND_GAS",
  "RETAIL",
  "FINANCIALS",
  "INFORMATION_TECHNOLOGY",
  "REAL_ESTATE",
  "HEALTH_CARE",
  "FAST_MOVING_CONSUMER_GOODS",
  "INDUSTRIAL",
  "UTILITIES",
  "PROFESSIONAL_SERVICES",
  "NON_PROFIT_ORGANIZATION",
  "AGRICULTURE",
  "TRADING",
  "OTHERS",
];

export const TRAVEL_SPENDINGS = [
  "SPENDING_MORE_1000_MIL",
  "SPENDING_BETWEEN_500_1000_MIL",
  "SPENDING_BETWEEN_250_500_MIL",
  "SPENDING_BETWEEN_50_250_MIL",
  "SPENDING_BETWEEN_15_50_MIL",
  "SPENDING_LESS_15_MIL",
];

export const POSITIONS = ["DIRECTOR", "ATTORNEY_IN_FACT"];

export const BILLING_CYCLES = ["BIWEEKLY", "MONTHLY"];

export const TERMS_OF_PAYMENTS = { HALF_MONTH: "15", FULL_MONTH: "30" };

export enum ExistingProductTypes {
  FLIGHT = "FLIGHT",
  HOTEL = "HOTEL",
}

export enum RequestProductType {
  CAR_RENTAL = "CAR_RENTAL",
  AIRPORT_TRANSPORT = "AIRPORT_TRANSPORT",
  INSURANCE = "INSURANCE",
}
